import {Form, formsStore, Record} from '../../../stores/Form';
import {getFormStatuses, getSavedSearchesAction} from '../../Form/actions/form';
import {
    addNewStandAloneForm,
    startStandAloneForm,
    updateCurrentRecordField
} from '../../Form/actions/standAloneForm';
import {
    ADDTODLVTRACKITEMS,
    ADPFetchMax,
    ADVDISTRDATA,
    DLVTRACK,
    DLVTRACKI,
    DLVTRACKS,
    DOCGUID,
    LOADADVDISTRDATANOI,
    MOVEDLVTRACKITEMS,
    STATUS_FIELD,
    ADDDOCSTODELPLAN,
    UPDDELIVERYORDER,
    OPTDELIVERYORDER,
    LORRIES,
    ColumnsNamesForLorries,
    LORRYTYPES,
    ColumnsNamesForLorryTypes,
    DLVGROUPS,
    ColumnsNamesForDeliveryGroups,
    DLVSTARTROUTEADDRESS,
    DLVENDROUTEADDRESS,
    OPENANDOPTDELIVERY,
    CAPABILITY,
    DISTRLINE,
    ZONE
} from '../constants';
import {
    buildDataUrlFromParams,
    defaultUpdateFunction,
    processProcStepResultMessageHandler,
    runProcedure
} from '../../../services/webSdk/proc';
import {
    EditField,
    FileResult,
    InputFields,
    InputFieldsReturn,
    InputProcData,
    MessageProcData,
    ProcBaseData,
    ProcData
} from 'priority-web-sdk';
import {
    showConfirmMessage,
    showErrorMessage,
    showInfoMessage
} from '../../../_shared/Messages/actions/MessageActions';
import messagesText from '../../../_shared/Messages/texts';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {addAndApplyFilters, addFilters, applyFilters} from '../../Form/actions/filters';
import {priority} from '@priority-software/priority-proto-api/lib';
import {RouteType} from '../types';
import {startProcedure} from '../../../services/webSdk/service';
import {startAndFetchSubform} from '../../Form/actions/batchedActions/standAloneFormBatch';
import {buildAddress, mappedColumnIds} from '../utils';
import {getUuid4} from '../../../utils/getUuid4';
import {endProc} from '../../../_shared/GWTBridge/invoke/procMain';
import {undoAll} from '../../Form/actions/undo';
import {addNewScreen, handleScreenMessage} from '../../Form/actions/screen';
import {BatchRequest} from '../../../services/proto/core/batchRequest';
import {batchKeys} from '../../../services/proto/core/constants';
import {getAdditionalProps} from '../../../services/proto/core/loginProps';
import {Dictionary} from '../../EOYWizard/types';
import stringify from 'json-stable-stringify';

export type ResponseADP = {
    planningForm: Form | null;
    routesForm: Form | null;
};

export const cleanNumberString = (str: string) => {
    return str.replace(/[.,]/g, '');
};

export const fetchSubform = async (form: Form, name: string, hiddenFields: string[] = []) => {
    await startAndFetchSubform(form, name, 0, hiddenFields);
    return form.activeSubForm;
};

export const optimizeDeliveryOrderForRoutes = async (
    data: any,
    isUnassignedOptimization: boolean,
    dname: string
) => {
    const procRes: ProcData = await startProcedure(
        isUnassignedOptimization ? OPENANDOPTDELIVERY : OPTDELIVERYORDER,
        'P',
        dname
    );
    return optimizeDeliveryOrderForRoutesProcStepResult(procRes, data);
};

export const optimizeDeliveryOrderForRoutesProcStepResult = async (
    procRes: ProcData,
    data: any
) => {
    return new Promise(async (resolve, reject) => {
        const proc = procRes.proc;
        switch (procRes.type) {
            case 'message':
                processProcStepResultMessageHandler(
                    resolve,
                    reject,
                    optimizeDeliveryOrderForRoutesProcStepResult,
                    procRes,
                    data,
                    undefined,
                    undefined
                );
                break;
            case 'upload':
                const mimeType = 'text/plain';
                const dataUrl = `data:${mimeType};base64,${btoa(stringify(data))}`;
                console.log('Sending to a procedure', data);
                const uploadRes: FileResult = await proc.uploadDataUrl(dataUrl, mimeType, () => {});
                resolve(
                    optimizeDeliveryOrderForRoutesProcStepResult(
                        uploadRes as unknown as ProcData,
                        data
                    )
                );
                break;
            case 'end':
                resolve('');
                break;
            default:
                break;
        }
    });
};

export const moveBetweenTrackingDocuments = async (
    fromId: string,
    toId: string,
    selectedRecords: Record[],
    dname: string
) => {
    return await runProcedure(
        MOVEDLVTRACKITEMS,
        updateMoveBetweenTrackingDocumentsInputFields(
            fromId,
            toId,
            selectedRecords.map(record =>
                cleanNumberString(
                    record.getField(record.parentForm.getColumnByName(DLVTRACKI).id)
                        .currentValue as string
                )
            )
        ),
        null,
        null,
        dname
    );
};

export const updateMoveBetweenTrackingDocumentsInputFields =
    (fromId: string, toId: string, selectedRecordsIds: string[]) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            switch (field.field) {
                case 1:
                    value = fromId;
                    break;
                case 2:
                    value = toId;
                    break;
                case 3:
                    value = selectedRecordsIds.join(' OR ');
            }
            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };

export const moveToTrackingDocuments = async (
    toId: string,
    selectedRecords: Record[],
    dname: string
) => {
    return await runProcedure(
        ADDTODLVTRACKITEMS,
        updateMoveToTrackingDocumentsInputFields(toId),
        null,
        () =>
            buildDataUrlFromParams(
                selectedRecords.map(record =>
                    cleanNumberString(
                        record.getField(record.parentForm.getColumnByName(DOCGUID).id)
                            .currentValue as string
                    )
                )
            ),
        dname
    );
};

export const updateMoveToTrackingDocumentsInputFields =
    (toId: string) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            switch (field.field) {
                case 1:
                    value = toId;
                    break;
            }
            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };

export const changeDeliveryLocationsOrders = async (
    trackingDocument: string,
    locationsToMove: string[],
    afterLocation: string,
    dname: string
) => {
    return await runProcedure(
        UPDDELIVERYORDER,
        updateUPDDELIVERYORDERInputFields(
            trackingDocument,
            locationsToMove.map(l => cleanNumberString(l)),
            cleanNumberString(afterLocation)
        ),
        null,
        null,
        dname
    );
};

export const updateUPDDELIVERYORDERInputFields =
    (trackingDocument: string, locationsToMove: string[], afterLocation: string) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            switch (field.field) {
                case 1:
                    value = trackingDocument;
                    break;
                case 2:
                    value = locationsToMove.join(' OR ');
                    break;
                case 3:
                    value = afterLocation;
                    break;
            }
            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };

export const loadADPForm = async (
    onLoadSuccess: () => Promise<ResponseADP>,
    dname: string
): Promise<ResponseADP> => {
    const procRes: ProcData = await startProcedure(LOADADVDISTRDATANOI, 'P', dname);
    if (procRes.type === 'message' && (procRes as MessageProcData).messagetype === 'information') {
        return onLoadSuccess();
    } else {
        await processProcStepResult(procRes, defaultUpdateFunction);
        return null;
    }
};

export const startADPForms = async () => {
    const [planningForm, routesForm] = await Promise.all([openPlanningForm(), openRoutesForm()]);
    return {planningForm, routesForm};
};

export const openPlanningForm = async () => {
    const planningForm = await addNewStandAloneForm(
        ADVDISTRDATA,
        {},
        null,
        ADPFetchMax,
        [DOCGUID, CAPABILITY, DISTRLINE, ZONE],
        {onErrorAccept: endProc}
    );
    if (!planningForm) {
        return null;
    }
    const isDefaultSearchApplied = await getSavedSearchesAction(planningForm, true);
    if (!isDefaultSearchApplied) {
        await fetchAllInTheBackground(planningForm);
    }
    return planningForm;
};

export const openRoutesForm = async () => {
    const routesForm = await addNewStandAloneForm(DLVTRACKS, {}, null, ADPFetchMax, [DLVTRACK], {
        onErrorAccept: endProc
    });
    if (!routesForm) {
        return null;
    }
    await getFormStatuses(routesForm);
    await getSavedSearchesAction(routesForm, true);
    return routesForm;
};

export const loadSubformsForSpecificRows = async (
    form: Form,
    subforms: string[],
    recordIndexes: number[],
    throwExceptionOnError: boolean = true,
    hiddenFieldsGenerator?: (subform: string) => string[] | undefined
) => {
    const session = form.session;
    const batchRequest = new BatchRequest(session);

    for (let i = 0; i < recordIndexes.length; ++i) {
        for (const subform of subforms) {
            batchRequest.addTask({
                key: batchKeys.Subform,
                request: new priority.netitems.form.SubformRq({
                    Fname: subform,
                    Keys: form.records[recordIndexes[i]].keys,
                    Session: form.session,
                    Properties: getAdditionalProps(),
                    hiddenFields: hiddenFieldsGenerator ? hiddenFieldsGenerator(subform) : undefined
                })
            });

            if (i === 0) {
                batchRequest.addTask({
                    key: batchKeys.Columns,
                    request: new priority.netitems.form.ColumnsRq({
                        Session: session,
                        Properties: getAdditionalProps()
                    }),
                    cacheData: undefined
                });
            }

            batchRequest.addTask({
                key: batchKeys.Fetch,
                request: new priority.netitems.form.FetchRq({
                    Session: form.session,
                    Properties: getAdditionalProps(),
                    Filters: [],
                    Sort: form.sort,
                    Top: 0,
                    Attachments: priority.netitems.form.AttachmentOptions.Attach_NoData
                })
            });

            batchRequest.addTask({
                key: batchKeys.End,
                request: new priority.netitems.form.EndRq({
                    Session: form.session,
                    Properties: getAdditionalProps()
                })
            });
        }
    }

    const responses: priority.netitems.form.INet2Grpc[] = await batchRequest.getData({
        canCancel: true,
        ignoreDefaultScreenLocker: true
    });

    if (responses.length === 0 && batchRequest.tasks.length !== 0 && throwExceptionOnError) {
        throw new Error('No responses for batch request');
    }

    const result: Dictionary<Dictionary<Form>> = {};

    for (let i = 0; i < recordIndexes.length; ++i) {
        for (let j = 0; j < subforms.length; ++j) {
            const recordsOffset =
                i === 0 ? 0 : subforms.length * 4 + (i - 1) * (subforms.length * 3);
            const subformsOffset = i === 0 ? j * 4 : j * 3;
            const offset = recordsOffset + subformsOffset;
            const startRs = responses[offset]?.Subform;
            const columnRs = responses[j * 4 + 1]?.Columns;
            const fetchRs = responses[offset + (i == 0 ? 2 : 1)]?.Fetch;

            if (startRs) {
                const isFormOk = await handleScreenMessage(startRs);
                if (isFormOk) {
                    if (columnRs) {
                        const subForm = new Form(subforms[j], startRs, columnRs, form.level + 1);

                        await handleScreenMessage(fetchRs, {}, () => {
                            subForm.setRecords(fetchRs.Records);
                            subForm.setShouldFetchMore(false);
                            subForm.setParentForm(form);
                            if (!result[recordIndexes[i].toString()]) {
                                result[recordIndexes[i].toString()] = {};
                            }
                            result[recordIndexes[i].toString()][subforms[j]] = subForm;
                        });
                    }
                }
            }
        }
    }

    return result;
};

export const refetchInTheBackground = async (form: Form, fetchAllDefault: boolean = true) => {
    if (form.filters?.length > 0) {
        await applyFilters(
            {
                form,
                filtersOperator: priority.netitems.shared.LogicalOperator.And
            },
            true,
            true
        );
    } else if (fetchAllDefault) {
        await fetchAllInTheBackground(form);
    }
};

export const fetchAllInTheBackground = async (form: Form) => {
    await addAndApplyFilters(
        form,
        [
            {
                fieldId: form?.columns?.find(c => c.Type === priority.netitems.form.ColumnType.Str)
                    ?.id,
                value: '*'
            }
        ],
        ADPFetchMax,
        false
    );
};

export const processProcStepResult = async (procRes: ProcData, updateFunc) => {
    return new Promise(async (resolve, reject) => {
        const proc = procRes.proc;
        switch (procRes.type) {
            case 'inputFields':
                const input: InputFields = (procRes as InputProcData).input as InputFields;
                const inputFields: EditField[] = input.EditFields;
                const updatedInputFields: InputFieldsReturn = updateFunc(inputFields);
                const res = await proc.inputFields(1, updatedInputFields);
                resolve(processProcStepResult(res, updateFunc));
                break;
            case 'message':
                const msgRes = procRes as ProcBaseData & MessageProcData;
                if (msgRes.messagetype === 'information') {
                    showInfoMessage({content: msgRes.message});
                    const res = await proc.continueProc();
                    if (res.type === 'end') {
                        const magParts = msgRes.message.split(' ');
                        const parseRes = Number(magParts[0]);
                        if (isNaN(parseRes)) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    } else {
                        resolve(processProcStepResult(res, updateFunc));
                    }
                } else if (msgRes.messagetype === 'warning') {
                    const processProcContinue = async () => {
                        const res = await proc.continueProc();
                        resolve(processProcStepResult(res, updateFunc));
                    };
                    showConfirmMessage({
                        content: msgRes.message,
                        onConfirm: processProcContinue,
                        confirmButtonText: messagesText.yes,
                        cancleButtonText: messagesText.cancel,
                        defaultButton: 0
                    });
                } else if (msgRes.messagetype === 'error') {
                    showErrorMessage({
                        title: msgRes.message,
                        onConfirm: () => reject(),
                        onClose: () => reject(),
                        confirmButtonText: getLocalizedText(texts.confirmLabel)
                    });
                }
                break;
            case 'end':
                resolve(false);
                break;
            default:
                break;
        }
    });
};

export const updateStatus = async (form: Form, selectedRecords: RouteType[], status: string) => {
    for (let i = 0; i < selectedRecords.length; i++) {
        const record = selectedRecords[i];
        form.setCurrentRow(record.data.recordIndex);
        await updateCurrentRecordField(form, STATUS_FIELD, status);
        const screen = formsStore.getScreenBySession(form.session);
        const isOk = await screen.saveRecord();
        if (!isOk) {
            await undoAll(formsStore.getScreenBySession(form.session));
        }
    }
};

export const addDocumentsToDeliveryPlan = async (
    date: string,
    selectedRecords: Record[],
    dname: string
) => {
    return await runProcedure(
        ADDDOCSTODELPLAN,
        updateAddDocsToDeliveryPlanInputFields(date),
        null,
        () =>
            buildDataUrlFromParams(
                selectedRecords.map(record =>
                    cleanNumberString(
                        record.getField(record.parentForm.getColumnByName(DOCGUID).id)
                            .currentValue as string
                    )
                )
            ),
        dname
    );
};

export const updateAddDocsToDeliveryPlanInputFields =
    (date: string) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            switch (field.field) {
                case 1:
                    value = date;
                    break;
                case 2:
                    value = date ? 'N' : 'Y';
                    break;
            }
            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };

export const openLorryTypesForm = async (filterValues: string[], dname: string) => {
    const lorryTypesForm: Form | null = await startStandAloneForm(
        LORRYTYPES,
        undefined,
        false,
        {
            onErrorAccept: endProc
        },
        {
            ignoreDefaultScreenLocker: true
        },
        dname
    );

    const LTCODE_id = lorryTypesForm.getColumnByName(ColumnsNamesForLorryTypes.LTCODE)?.id;

    if (lorryTypesForm) {
        const filterParams = filterValues.map(x => ({
            fieldId: LTCODE_id,
            value: x,
            operator: priority.netitems.shared.ComparisonOperator.Eq
        }));
        lorryTypesForm.sort = null;

        addFilters(lorryTypesForm, filterParams);
        await applyFilters({
            form: lorryTypesForm,
            top: undefined,
            filtersOperator: priority.netitems.shared.LogicalOperator.Or
        });

        addNewScreen(lorryTypesForm, null, true);
    }

    if (!lorryTypesForm) {
        return null;
    }
    return lorryTypesForm;
};

export const openLorriesForm = async (dname: string) => {
    const lorriesForm = await addNewStandAloneForm(
        LORRIES,
        {[ColumnsNamesForLorries.LORRYNUM]: '*', [ColumnsNamesForLorries.OPTIMIZATION]: 'Y'},
        null,
        0,
        undefined,
        {
            onErrorAccept: endProc
        },
        {
            ignoreDefaultScreenLocker: true
        },
        dname
    );
    if (!lorriesForm) {
        return null;
    }
    return lorriesForm;
};

export const openDeliveryGroupsForm = async (filterValues: string[], dname: string) => {
    const deliveryGroupsForm: Form | null = await startStandAloneForm(
        DLVGROUPS,
        undefined,
        false,
        {
            onErrorAccept: endProc
        },
        {
            ignoreDefaultScreenLocker: true
        },
        dname
    );

    const DLVGROUPCODE_id = deliveryGroupsForm.getColumnByName(
        ColumnsNamesForDeliveryGroups.DLVGROUPCODE
    )?.id;

    if (deliveryGroupsForm) {
        const filterParams = filterValues.map(x => ({
            fieldId: DLVGROUPCODE_id,
            value: x,
            operator: priority.netitems.shared.ComparisonOperator.Eq
        }));
        deliveryGroupsForm.sort = null;

        addFilters(deliveryGroupsForm, filterParams);
        await applyFilters({
            form: deliveryGroupsForm,
            top: undefined,
            filtersOperator: priority.netitems.shared.LogicalOperator.Or
        });

        addNewScreen(deliveryGroupsForm, null, true);
    }

    if (!deliveryGroupsForm) {
        return null;
    }
    return deliveryGroupsForm;
};

export const processRouteWarehousesData = (route: RouteType, data: Dictionary<Form>) => {
    if (!route.startMarker) {
        const routesForm = route.data.parentForm;
        if (routesForm.records.length) {
            const columnMapStart = mappedColumnIds(data[DLVSTARTROUTEADDRESS].columns);
            if (data[DLVSTARTROUTEADDRESS].records.length) {
                const latIdStart = columnMapStart['GPSX'];
                const latStart =
                    data[DLVSTARTROUTEADDRESS].records[0].getField(latIdStart).origValue;
                const lngIdStart = columnMapStart['GPSY'];
                const lngStart =
                    data[DLVSTARTROUTEADDRESS].records[0].getField(lngIdStart).origValue;
                route.startMarker = {
                    id: getUuid4(),
                    address: buildAddress(data[DLVSTARTROUTEADDRESS].records[0], columnMapStart),
                    label: 'S',
                    selected: false,
                    lat: Number(latStart),
                    lng: Number(lngStart),
                    color: route?.color,
                    route: route,
                    show: true,
                    isStart: true
                };
            }

            const columnMapEnd = mappedColumnIds(data[DLVENDROUTEADDRESS].columns);
            if (data[DLVENDROUTEADDRESS].records.length) {
                const latIdEnd = columnMapEnd['GPSX'];
                const latEnd = data[DLVENDROUTEADDRESS].records[0].getField(latIdEnd).origValue;
                const lngIdEnd = columnMapEnd['GPSY'];
                const lngEnd = data[DLVENDROUTEADDRESS].records[0].getField(lngIdEnd).origValue;
                route.endMarker = {
                    id: getUuid4(),
                    address: buildAddress(data[DLVENDROUTEADDRESS].records[0], columnMapEnd),
                    label: 'E',
                    selected: false,
                    lat: Number(latEnd),
                    lng: Number(lngEnd),
                    color: route?.color,
                    route: route,
                    show: true,
                    isEnd: true
                };
            }
        }
    }
};
